
export default {
  apiKey: "@@apiKey",
  authDomain: "@@authDomain",
  databaseURL: "@@databaseURL",
  projectId: "@@projectId",
  storageBucket: "@@storageBucket",
  messagingSenderId: "@@messagingSenderId"
}
